import React from "react";
import { UncontrolledCliProps } from "./types";
import { ControlledCommandLine } from "./ControlledCommandLine";

export const UncontrolledCommandLine: React.FC<UncontrolledCliProps> = ({
    initialValue = "",
    onSubmit,
}) => {
    const [value, setValue] = React.useState<string>(initialValue);

    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    return (
        <ControlledCommandLine
            value={value}
            onChange={value => {
                setValue(value);
            }}
            onSubmit={value => {
                onSubmit(value);
            }}
            error={false}
        />
    );
};
